import {Contract} from 'ethers';
import {createContext, ReactNode, useContext} from 'react';

const MonaTokensContractContext = createContext<Contract>({} as Contract);

export function MonaTokensContractProvider({
  contract,
  children,
}: {
  contract: Contract | null;
  children: ReactNode;
}) {
  return (
    <MonaTokensContractContext.Provider value={contract || ({} as Contract)}>
      {contract ? children : null}
    </MonaTokensContractContext.Provider>
  );
}

export function useMonaTokensContract() {
  return useContext(MonaTokensContractContext);
}
